import axios from './index';
export default {
  // 获取所有
  listAll: () => {
    return axios.get('/admins/listall');
  },

  // 分页查询
  page: (params) => {
    return axios.get('/admins/listpage', { params });
  },

  // // 根据ID获取
  // getById: (id) => {
  //   return axios.get(`/admins/${id}`);
  // },

  // 新增
  create: (data) => {
    return axios.post('/admins', data);
  },

  // 编辑
  update: (data) => {
    return axios.put('/admins', data);
  },

  // 删除
  remove: (id) => {
    return axios.delete(`/admins/${id}`);
  },

  // 登录
  login: (data) => {
    return axios.post('/admins/login', data);
  },
};
